import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { topicTags } from '@/mocks/home';

const toneStyles = [
  'bg-primary-100 text-primary-800 border-primary-200',
  'bg-secondary-100 text-secondary-800 border-secondary-200',
  'bg-accent-100 text-accent-800 border-accent-200',
  'bg-background-200 text-foreground-800 border-background-300',
];

export default function TagWall() {
  const [selected, setSelected] = useState<string[]>(['影视观看', '官网入口']);

  const toggle = (tag: string) => {
    setSelected((current) =>
      current.includes(tag) ? current.filter((t) => t !== tag) : [...current, tag],
    );
  };

  return (
    <section id="tags" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <SectionHeading
        index="05"
        eyebrow="Topic Wall"
        title="话题墙 · 你可能会关心的入口标签"
        desc="把最常见的访问诉求做成标签墙。点一点你关心的标签，能更直观地看出本页覆盖了哪些入口方向。"
      />

      <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
        <div className="flex flex-wrap gap-3">
          {topicTags.map((tag, index) => {
            const isSelected = selected.includes(tag);
            const tone = toneStyles[index % toneStyles.length];
            return (
              <button
                key={tag}
                type="button"
                onClick={() => toggle(tag)}
                aria-pressed={isSelected}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full border font-label text-sm transition-all cursor-pointer whitespace-nowrap ${
                  isSelected
                    ? 'bg-primary-500 text-background-50 dark:text-foreground-950 border-primary-500'
                    : `${tone} hover:border-primary-300`
                }`}
              >
                {isSelected && <i className="ri-check-line text-xs" aria-hidden="true"></i>}
                {tag}
              </button>
            );
          })}
        </div>

        <div className="mt-7 pt-6 border-t border-background-200 flex flex-col sm:flex-row sm:items-center gap-3">
          <span className="font-label text-sm text-foreground-600">
            已选中 <strong className="font-heading font-bold text-primary-700">{selected.length}</strong> 个标签
          </span>
          <span className="hidden sm:block w-px h-4 bg-background-300" />
          <span className="font-label text-xs text-foreground-500">
            {selected.length > 0 ? selected.join(' · ') : '暂无选择，点上方标签试试'}
          </span>
        </div>
      </div>
    </section>
  );
}